import EditResource from './EditResource';

export default EditResource;
